module.exports = "/_next/static/images/d697319098e5ca22f790075f01d7137a-woman-with-sandwich@1x.jpg.webp";